document.addEventListener('DOMContentLoaded', () => {
  // Solo correr en el carrito
  if (!window.location.pathname.includes('/cart')) return;

  // URL del CSV subido a Archivos
  const DELIVERY_TIMES_CSV_URL = '{{ "delivery-times.csv" | file_url }}';

  const zipToTime = {};

  // Traer y leer el CSV (asumimos: col A = CP, col B = tiempo)
  fetch(DELIVERY_TIMES_CSV_URL)
    .then(response => response.text())
    .then(text => {
      const lines = text.split(/\r?\n/).filter(l => l.trim().length);
      if (lines.length <= 1) return;

      // Nos saltamos la primera fila (encabezados)
      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(/[,;]+/); // coma o punto y coma
        const cp = (cols[0] || '').trim();
        const time = (cols[1] || '').trim();
        if (cp && time) {
          zipToTime[cp] = time;
        }
      }
      console.log('Tiempos de entrega cargados:', Object.keys(zipToTime).length);
    })
    .catch(err => {
      console.error('Error cargando tiempos de entrega', err);
    });

  // Buscar el formulario de carrito
  const cartForm =
    document.querySelector('form[action="/cart"]') ||
    document.querySelector('form[action*="/cart"]');
  if (!cartForm) return;

  // Crear el widget debajo del carrito
  const wrapper = document.createElement('div');
  wrapper.className = 'delivery-time-widget';
  wrapper.innerHTML = `
    <div style="margin-top:16px;padding:12px;border-radius:8px;border:1px solid #e0e0e0;">
      <label for="delivery-zipcode" style="display:block;font-weight:600;margin-bottom:4px;">
        Ingresá tu código postal para conocer el tiempo estimado de entrega
      </label>
      <div style="display:flex;gap:8px;align-items:center;margin-bottom:4px;">
        <input id="delivery-zipcode" type="text" inputmode="numeric" pattern="[0-9]*"
          style="flex:1;padding:8px;border-radius:6px;border:1px solid #ccc;" placeholder="Ej: 06000">
        <button type="button" id="delivery-zipcode-btn"
          style="padding:8px 14px;border-radius:6px;border:none;background:#008060;color:#fff;font-weight:600;cursor:pointer;">
          Calcular
        </button>
      </div>
      <p id="delivery-zipcode-result" style="margin:0;font-size:0.9rem;color:#333;min-height:1.2em;"></p>
    </div>
  `;
  cartForm.parentNode.insertBefore(wrapper, cartForm.nextSibling);

  function showResult() {
    const input = document.getElementById('delivery-zipcode');
    const result = document.getElementById('delivery-zipcode-result');
    if (!input || !result) return;

    let cp = (input.value || '').trim();
    cp = cp.replace(/\D/g, ''); // solo números

    if (!cp) {
      result.textContent = 'Por favor, ingresá un código postal válido.';
      return;
    }

    const time = zipToTime[cp];
    if (time) {
      result.textContent = `Tiempo estimado de entrega para ${cp}: ${time}.`;
    } else {
      result.textContent =
        'Por el momento no tenemos un tiempo estimado para este código postal. Te vamos a contactar luego de la compra para coordinar el envío.';
    }
  }

  // Click en botón "Calcular"
  wrapper.addEventListener('click', (evt) => {
    if (evt.target && evt.target.id === 'delivery-zipcode-btn') {
      showResult();
    }
  });

  // También calcular al presionar Enter dentro del input
  wrapper.addEventListener('keypress', (evt) => {
    if (evt.target && evt.target.id === 'delivery-zipcode' && evt.key === 'Enter') {
      evt.preventDefault();
      showResult();
    }
  });
});
